module.exports = __webpack_public_path__ + "static/img/26.72bdf939.png";